import { render, staticRenderFns } from "./HeaderAuthor.vue?vue&type=template&id=e733247c&scoped=true"
import script from "./HeaderAuthor.vue?vue&type=script&lang=js"
export * from "./HeaderAuthor.vue?vue&type=script&lang=js"
import style0 from "./HeaderAuthor.vue?vue&type=style&index=0&id=e733247c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e733247c",
  null
  
)

export default component.exports